import { RadioProps } from "@insite/mobius/Radio";
import { RadioGroupProps } from "@insite/mobius/RadioGroup";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import FieldSetPresentationProps, { FieldSetGroupPresentationProps } from "@insite/mobius/utilities/fieldSetProps";
import getColor from "@insite/mobius/utilities/getColor";
import RecursivePartial from "@insite/mobius/utilities/RecursivePartial";
import { colorStrings, mediaQueriesBP } from "@solveindustrial/Utilities/variables";
import { css } from "styled-components";

export const radio: RecursivePartial<{
    defaultProps?: FieldSetPresentationProps<RadioProps> | undefined;
    groupDefaultProps?: FieldSetGroupPresentationProps<RadioGroupProps> | undefined;
}> = {
    defaultProps: {
        color: colorStrings.commonGlobalWhite,
        mergeCss: true,
        css: css`
            &&& > input {
                border-color: ${getColor(colorStrings.commonGlobalBlack)};
                height: 16px;
                width: 16px;

                &:focus {
                    border: 0;
                    & + ${TypographyStyle} {
                        &::before {
                            box-shadow: none;
                        }
                    }
                }

                &:checked:not(:disabled) {
                    & + ${TypographyStyle} {
                        font-weight: 700;
                        color: ${getColor(colorStrings.primaryMain)};
                        &::before {
                            border-color: ${getColor(colorStrings.primaryMain)};
                            background-color: ${getColor(colorStrings.primaryMain)};
                            height: 16px;
                            width: 16px;
                        }

                        &::after {
                            background-color: ${getColor(colorStrings.commonGlobalWhite)};
                            height: 8px;
                            width: 8px;
                            left: 4px;
                            top: calc(50% - 4px);
                        }
                    }
                }

                & + ${TypographyStyle} {
                    color: ${getColor(colorStrings.commonGlobalBlack)};
                    font-size: 14px;
                    line-height: 14px;
                    height: 18px;
                    ${mediaQueriesBP.minMD} {
                        font-size: 16px;
                        line-height: 16px;
                    }

                    &::before {
                        border-color: ${getColor(colorStrings.commonGlobalBlack)};
                        height: 16px;
                        width: 16px;
                    }

                    &::after {
                        background-color: ${getColor(colorStrings.commonGlobalWhite)};
                        height: 8px;
                        width: 8px;
                        left: 4px;
                        top: calc(50% - 4px);
                    }
                }
            }
        `,
    },
};
